import TextInput from '../../../Shared/TextInput/TextInput';
import React, {useState, useRef, useEffect} from 'react';
import {connect} from 'react-redux';
import ReactSelect from '../../../Shared/ReactSelect/ReactSelect';
import {setSelectedUser, deleteOrgUser, setShowPopUp, updateOrgUserByContact} from '../OrgUsersManagementSlice';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {getStatusTextAndColor, MessageContent, PopUp} from '../General';
import Image from 'app/Components/Shared/Image/image';
const UpdateUserPopUp = ({data, setSelectedUser, setShowPopUp, updateOrgUserByContact}) => {
  const statusDetails = getStatusTextAndColor(data.selectedUser.status);
  const fullNameRef = useRef();

  const getPlaceHolder = (value, placeholder, isReactSelect = false) => {
    if (value != '') {
      if (isReactSelect) return placeholder + ' - ' + value;
      else return placeholder;
    }
    return `לא נבחר ${placeholder}`;
  };

  return (
    <div className='User_Card'>
      <p className='L_title'> דו"ח פיצול</p>
      <p className='status_text' style={{backgroundColor: statusDetails.color}}>
        <span className='bold'>{statusDetails.status}</span> <span>{statusDetails.text && '-' + statusDetails.text}</span>{' '}
      </p>
      <TextInput
        ref={fullNameRef}
        value={data.selectedUser.fullName}
        id='fullName'
        placeholder={'שם מנוי'}
        disabled={!data.selectedUser.canUpdateFullRow}
        onChange={(e) => {
          setSelectedUser({...data.selectedUser, fullName: e.target.value});
        }}
      />
      <div className='inputContainer'>
        <TextInput value={data.selectedUser.userId} id='userId' placeholder={'מספר זהות'} disabled={true} />
        <TextInput value={data.selectedUser.subscriberNumber} id='subscriberNumber' placeholder={'מספר נייד'} disabled={true} />
        <TextInput value={data.selectedUser.amountOfFunding} id='amountOfFunding' placeholder={'סכום פיצול'} disabled={true} />
      </div>
      <ReactSelect
        getOptionLabel={(option) => option}
        getOptionValue={(option) => option}
        disabled={!data.selectedUser.canUpdateFullRow}
        placeholder={'מדרג-' + data.selectedUser.userType}
        value={data.selectedUser.userType}
        options={data.userTypeList}
        name='userType'
        onChange={(value) => {
          setSelectedUser({...data.selectedUser, userType: value});
        }}
      />
      <TextInput
        value={data.selectedUser.phoneModelName}
        id='phoneType'
        placeholder={getPlaceHolder(data.selectedUser.phoneModelName, 'סוג מכשיר')}
        disabled={true}
      />
      <TextInput
        value={data.selectedUser.planName}
        id='planName'
        placeholder={getPlaceHolder(data.selectedUser.planName, 'תוכנית')}
        disabled={true}
      />
      <ReactSelect
        getOptionLabel={(option) => option}
        getOptionValue={(option) => option}
        placeholder={getPlaceHolder(data.selectedUser.distributionCenter, 'איזור חלוקה', true)}
        value={data.selectedUser.distributionCenter}
        options={data.distributionCenterList}
        id='distributionCenter'
        name='distributionCenter'
        onChange={(value) => {
          setSelectedUser({...data.selectedUser, distributionCenter: value});
        }}
      />
      <div className='buttom_btn_container'>
        <button
          disabled={!(data.selectedUser.canRemoveUser || data.selectedUser.canUpdateFullRow)}
          className='whiteBtn'
          onClick={() => setShowPopUp({show: true, message: MessageContent.DeleteUserConfirmation, type: PopUp.GeneralMessage})}>
          <Image src={require('../icons/bin.svg')} />
          מחיקת מנוי
        </button>
        <button
          onClick={() => setShowPopUp({show: true, message: MessageContent.SendLinkConfirmation, type: PopUp.GeneralMessage})}
          className='whiteBtn'>
          <Image src={require('../icons/send.svg')} />
          שליחה חוזרת למנוי
        </button>
      </div>
      <BtnSubmit
        width={290}
        text={'שמירת שינויים'}
        onclick={async () => {
          await updateOrgUserByContact();
        }}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    data: state.orgUsersManagement,
  };
};

const mapDispatchToProps = {setSelectedUser, deleteOrgUser, setShowPopUp, updateOrgUserByContact};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserPopUp);
